export const TASK_STATE_COLORS: Record<string, string> = {
  READY: '#2e92f2',
  WAITING: '#1f62a2',
  RUNNING: '#f4b90b',
  FAILED: '#db0051',
  COMPLETED: '#24c75a',
  RESERVED: '#bb8bc1',
  ARCHIVED: '#7f8287',
  CANCELLED: '#b7bcc3',
  PAUSING: '#f5a08c',
  PAUSED: '#ffcfca',
  EVICTING: '#e07a26',
};

export const FALLBACK_STATE_COLOR = '#767676';

export function taskStateColor(state: string): string {
  return TASK_STATE_COLORS[state.toUpperCase()] ?? FALLBACK_STATE_COLOR;
}

export const STATE_PRIORITY: Record<string, number> = {
  FAILED: 0,
  RUNNING: 1,
  EVICTING: 2,
  PAUSING: 3,
  READY: 4,
  WAITING: 5,
  PAUSED: 6,
  CANCELLED: 7,
  RESERVED: 8,
  COMPLETED: 9,
  ARCHIVED: 10,
};

export function statePriority(state: string): number {
  return STATE_PRIORITY[state] ?? 99;
}

export function buildBreakdownParts(stateCounts: Record<string, number>): string[] {
  return Object.entries(stateCounts)
    .filter(([, count]) => count > 0)
    .sort(([a], [b]) => statePriority(a) - statePriority(b))
    .map(([state, count]) => `${count} ${state.toLowerCase()}`);
}
